// extracted by mini-css-extract-plugin
module.exports = {"page_container":"Pagenotfound_page_container__2233X","page_heading":"Pagenotfound_page_heading__14wjW","page_message":"Pagenotfound_page_message__3alqC"};